import { useEffect, useState } from "react";
import { img } from "../lib/api";

const SRC = "https://ajax.googleapis.com/ajax/libs/model-viewer/4.0.0/model-viewer.min.js";

const loadScript = () => {
  if (window.customElements?.get("model-viewer")) return Promise.resolve();
  let s = document.querySelector(`script[src="${SRC}"]`);
  if (!s) { s = Object.assign(document.createElement("script"), { type: "module", src: SRC }); document.head.appendChild(s); }
  return window.customElements.whenDefined("model-viewer");
};

export default function ModelViewer({ src, poster, className = "w-full aspect-square h-auto rounded-3xl" }) {
  const [ready, setReady] = useState(!!window.customElements?.get("model-viewer"));
  useEffect(() => { loadScript().then(() => setReady(true)); }, []);
  if (!ready) return <div className={`${className} bg-[#12141c] border border-white/10 grid place-items-center text-sm text-slate-400`} data-testid="model-viewer-loading">Loading 3D model...</div>;
  return (
    <model-viewer data-testid="model-viewer" src={img(src)} poster={poster ? img(poster) : undefined} camera-controls="" auto-rotate="" touch-action="pan-y" shadow-intensity="1" ar="" ar-modes="webxr scene-viewer quick-look"
      exposure="1" style={{ background: "radial-gradient(circle at 50% 40%, #1d2030, #0b0c12)" }} class={`${className} block border border-white/10`} />
  );
}
